
// document.querySelectorAll('.faq-question').forEach(button => {
//   button.addEventListener('click', () => {
//     button.classList.toggle('active');
//     const answer = button.nextElementSibling;
//     const toggle = button.querySelector('.faq-toggle');
//     const isVisible = answer.style.display === 'block';
//     answer.style.display = isVisible ? 'none' : 'block';
//     toggle.textContent = isVisible ? '+' : '–';
//   });
// });
document.querySelectorAll('.faq-question').forEach(function (div) {
        div.addEventListener('click', function () {

            const accordionContent = div.nextElementSibling;
            div.classList.toggle('active');

            if (div.classList.contains('active')) {
                accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
                div.querySelector('.faq-toggle').textContent = '−';
            } else {
                accordionContent.style.maxHeight = 0;
                div.querySelector('.faq-toggle').textContent = '+';
            }

            // Close all others
            document.querySelectorAll('.faq-question').forEach(function (otherDiv) {
                if (otherDiv !== div) {
                    otherDiv.classList.remove('active');
                    otherDiv.nextElementSibling.style.maxHeight = 0;
                    otherDiv.querySelector('.faq-toggle').textContent = '+';
                }
            });

        });
    });